import { memoize, merge } from "lodash-es";
import { z } from "zod/v3";
const getAppConfig = memoize(_getAppConfig);
function _getAppConfig() {
    try {
        const appConfig = AppConfig.parse(window.chronoAppConfig);
        return appConfig;
    } catch (err) {
        console.error('Failed to get AppConfig from window object, using default values', err);
    }
    return getAppConfigDefaults();
}
function getAppConfigDefaults() {
    return {
        tenantNamespace: window.location.hostname.split('.')[0] ?? 'unknown',
        defaultRetention: '120h',
        enableExperimentalDashboardFeatures: false,
        enableAllVizFrameworkPlugins: false,
        enableChronosphereChangeEventLinks: false
    };
}
const nonEmptyString = z.string().min(1, {
    message: 'String cannot be empty'
});
const AppConfig = z.object({
    tenantNamespace: nonEmptyString,
    defaultRetention: nonEmptyString,
    enableExperimentalDashboardFeatures: z.boolean(),
    enableAllVizFrameworkPlugins: z.boolean(),
    enableChronosphereChangeEventLinks: z.boolean()
});
function setAppConfig(config) {
    if ('production' !== process.env.NODE_ENV) {
        const values = merge({}, getAppConfigDefaults(), config);
        window.chronoAppConfig = values;
    }
}
export { getAppConfig, getAppConfigDefaults, setAppConfig };

//# sourceMappingURL=app-config.js.map